import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;
const storageKey = 'complytradeiq-auth-token';
const inviteCallbackStorageKey = 'complytradeiq-invite-callback';
const storage = typeof window !== 'undefined' ? window.sessionStorage : undefined;

const getProjectRef = (value) => {
  try {
    return new URL(value).hostname.split('.')[0] || null;
  } catch {
    return null;
  }
};

export const supabase = url && key ? createClient(url, key, {
  auth: {
    storage,
    storageKey,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: (currentUrl, params) => {
      const isInviteRoute = currentUrl.pathname === '/set-password'
        && currentUrl.searchParams.get('invite') === '1';
      const hasAuthPayload = Boolean(
        params.access_token
        || params.refresh_token
        || params.code
        || params.error
        || params.error_description
      );

      if (typeof window !== 'undefined' && isInviteRoute && hasAuthPayload) {
        window.sessionStorage.setItem(inviteCallbackStorageKey, 'pending');
      }

      return Boolean(params.access_token || params.code || params.error || params.error_description);
    },
  },
}) : null;

export const supabaseReady = Boolean(supabase);
export const supabaseStorageKey = storageKey;
export const setInviteCallbackState = (value) => {
  if (typeof window === 'undefined') return;
  if (!value) {
    window.sessionStorage.removeItem(inviteCallbackStorageKey);
    return;
  }
  window.sessionStorage.setItem(inviteCallbackStorageKey, value);
};
export const getInviteCallbackState = () => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem(inviteCallbackStorageKey);
};
export const clearInviteCallbackState = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(inviteCallbackStorageKey);
};
export const legacySupabaseStorageKeys = (() => {
  const projectRef = getProjectRef(url);
  return projectRef ? [`sb-${projectRef}-auth-token`] : [];
})();
